import React from 'react'
import { Switch } from 'react-router-dom'
import ScrollToTop from '../../components/ScrollToTop'
import PrivateVetRoute from '../../components/PrivateVetRoute'

// Landing
import Home from '../../pages/Vets/Home'

// Tutors and Pets
import TutorsAndPets from '../../pages/Vets/TutorsAndPets'

// Pet and Tutor Details
import PetDetails from '../../pages/Vets/PetDetails'
import TutorDetails from '../../pages/Vets/TutorDetails'

// Terms and Policies
import PrivacyPolicy from '../../pages/Vets/PrivacyPolicy'
import UseTerm from '../../pages/Vets/UseTerm'

// Appointments
import Appointment from '../../pages/Vets/Appointment'

// Notifications
import Notifications from '../../pages/Vets/Notifications'
import NotificationDetail from '../../pages/Vets/Notifications/NotificationDetail'

// Dashboard
import Dashboard from '../../pages/Vets/Dashboard'
import ServicesDetails from '../../pages/Vets/Dashboard/ServicesDetails'
import ClientsDetails from '../../pages/Vets/Dashboard/ClientsDetails'
import BillingDetails from '../../pages/Vets/Dashboard/BillingDetails'
import DailyBilling from '../../pages/Vets/Dashboard/DailyBilling'
import SchedulingsDetails from '../../pages/Vets/Dashboard/SchedulingsDetails'
import StatusDetails from '../../pages/Vets/Dashboard/SchedulingsDetails/StatusDetails'
import DailyAttendance from '../../pages/Vets/Dashboard/DailyAttendance'

// Calendar
import DailyView from '../../pages/Vets/DailyView'
import MonthlyView from '../../pages/Vets/MonthlyView'

// Solicitations
import SolicitationsView from '../../pages/Vets/SolicitationsView'
import AgendaBlockSolicitationView from '../../pages/Vets/AgendaBlockSolicitationView'
import SchedulingSolicitationView from '../../pages/Vets/SchedulingSolicitationView'
import SolicitationsHistory from '../../pages/Vets/SolicitationsHistory'

const Vets = () => {
  return <>
    <Switch>
      <PrivateVetRoute path='/vets/solicitations/new-agenda-block'>
        <ScrollToTop />
        <AgendaBlockSolicitationView />
      </PrivateVetRoute>
      <PrivateVetRoute path='/vets/solicitations/new-scheduling'>
        <ScrollToTop />
        <SchedulingSolicitationView />
      </PrivateVetRoute>
      <PrivateVetRoute path='/vets/solicitations/solicitations-history'>
        <ScrollToTop />
        <SolicitationsHistory />
      </PrivateVetRoute>
      <PrivateVetRoute path='/vets/solicitations'>
        <ScrollToTop />
        <SolicitationsView />
      </PrivateVetRoute>
      <PrivateVetRoute path='/vets/calendar/monthly'>
        <ScrollToTop />
        <MonthlyView />
      </PrivateVetRoute>
      <PrivateVetRoute path='/vets/calendar/daily'>
        <ScrollToTop />
        <DailyView />
      </PrivateVetRoute>
      <PrivateVetRoute freelanceDisallowed path='/vets/dashboard/scheduling-details/daily'>
        <ScrollToTop />
        <DailyAttendance />
      </PrivateVetRoute>
      <PrivateVetRoute freelanceDisallowed path='/vets/dashboard/scheduling-details/status'>
        <ScrollToTop />
        <StatusDetails />
      </PrivateVetRoute>
      <PrivateVetRoute freelanceDisallowed path='/vets/dashboard/scheduling-details'>
        <ScrollToTop />
        <SchedulingsDetails />
      </PrivateVetRoute>
      <PrivateVetRoute freelanceDisallowed path='/vets/dashboard/billing/daily'>
        <ScrollToTop />
        <DailyBilling />
      </PrivateVetRoute>
      <PrivateVetRoute freelanceDisallowed path='/vets/dashboard/billing'>
        <ScrollToTop />
        <BillingDetails />
      </PrivateVetRoute>
      <PrivateVetRoute freelanceDisallowed path='/vets/dashboard/services/clients'>
        <ScrollToTop />
        <ClientsDetails />
      </PrivateVetRoute>
      <PrivateVetRoute freelanceDisallowed path='/vets/dashboard/services'>
        <ScrollToTop />
        <ServicesDetails />
      </PrivateVetRoute>
      <PrivateVetRoute freelanceDisallowed path='/vets/dashboard'>
        <ScrollToTop />
        <Dashboard />
      </PrivateVetRoute>
      <PrivateVetRoute path='/vets/notifications/notification-details/:id'>
        <ScrollToTop />
        <NotificationDetail />
      </PrivateVetRoute>
      <PrivateVetRoute path='/vets/notifications'>
        <ScrollToTop />
        <Notifications />
      </PrivateVetRoute>
      <PrivateVetRoute path='/vets/privacy-policy'>
        <ScrollToTop />
        <PrivacyPolicy />
      </PrivateVetRoute>
      <PrivateVetRoute path='/vets/termo-de-uso'>
        <ScrollToTop />
        <UseTerm />
      </PrivateVetRoute>
      <PrivateVetRoute path='/vets/detalhes-do-tutor/:id'>
        <ScrollToTop />
        <TutorDetails />
      </PrivateVetRoute>
      <PrivateVetRoute path='/vets/tutores-e-pets'>
        <ScrollToTop />
        <TutorsAndPets />
      </PrivateVetRoute>
      <PrivateVetRoute path='/vets/detalhes-do-pet/:id'>
        <ScrollToTop />
        <PetDetails />
      </PrivateVetRoute>
      <PrivateVetRoute path='/vets/prontuario'>
        <ScrollToTop />
        <Appointment />
      </PrivateVetRoute>
      <PrivateVetRoute path='/vets'>
        <ScrollToTop />
        <Home />
      </PrivateVetRoute>
    </Switch>
  </>
}

export default Vets
